import type { ComponentType } from "react";
import { About } from "./about";
import { Book } from "./book";
import { Consent } from "./consent";
import { Contact } from "./contact";
import { Home } from "./home";
import { Incoming } from "./incoming";
import { NotFound } from "./not-found";
import { Outgoing } from "./outgoing";
import { Referrals } from "./referrals";
import { Services } from "./services";

export { NotFound };

export const PAGES: Record<string, ComponentType> = {
  "/": Home,
  "/about": About,
  "/services": Services,
  "/referrals": Referrals,
  "/referrals/incoming": Incoming,
  "/referrals/outgoing": Outgoing,
  "/book": Book,
  "/consent": Consent,
  "/contact": Contact,
};
